//* startsWith('/donation')는 /donations·/donation-guide까지 통과시킨다
export const isDonationPath = (path: string) =>
  /^\/donation(?:[/?#]|$)/.test(path);
